// import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Secondbar from './Components/Secondbar/Secondbar';
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import ShopCategory from './Pages/ShopCategory';
import Brand from './Pages/Brand';
import Accessorie from './Pages/Accessorie';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
       <Navbar/>
       <Secondbar/>
        <Routes>
          {/* main */}
          <Route path='/' element={<Home/>} />
          <Route path='/homeproducts' element={<ShopCategory category="home"/> } />
          <Route path='/about' element={<About/>} />
          <Route path='/contact' element={<Contact/>} />

          {/* productroutes */}
          <Route path='/product' element={<Product/>} >
            <Route path=':productId' element={<Product/>} />
          </Route>

          {/* cartnlogin */}
          <Route path='/cart' element={ <Cart/> } />
          <Route path='/login' element={ <LoginSignup/> } />

          {/* subroutes */}
          <Route path='/ursa' element={<ShopCategory category="ursa"/> } />
          <Route path='/viviana' element={<ShopCategory category="viviana"/> } />
          <Route path='/hideamic' element={<ShopCategory category="hideamic"/> } />
          <Route path='/radiuswindshield' element={<ShopCategory category="radius"/> } />
          <Route path='/brand' element={ <Brand/> } />
          <Route path='/accessories' element={ <Accessorie/> } />

        </Routes>
        <Footer/>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
